// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px) {
  #copyright-notice {
    font-size: 12px;
  }

  .search-slide-down {
    width: 250px;
  }

  #ui-datepicker-div {
    top: var(--top-menu-height) !important;
    border: 5px solid var(--color-dark-border);
    left: calc(50% - 167.5px) !important;
    border-radius: 0px;
    bottom: unset;
    width: fit-content;
  }

  .ui-timepicker-div dl {
    text-align: center !important;
  }

  .ui-datepicker td a {
    padding: 0.2em;
  }

  .ui-datepicker .ui-datepicker-buttonpane button {
    padding: 0.2em 0.6em 0.3em 0.6em;
  }
}`, "",{"version":3,"sources":["webpack://./public/css/responsive-md.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sCAAsC;IACtC,0CAA0C;IAC1C,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;AACF","sourcesContent":["@media (min-width: 768px) {\n  #copyright-notice {\n    font-size: 12px;\n  }\n\n  .search-slide-down {\n    width: 250px;\n  }\n\n  #ui-datepicker-div {\n    top: var(--top-menu-height) !important;\n    border: 5px solid var(--color-dark-border);\n    left: calc(50% - 167.5px) !important;\n    border-radius: 0px;\n    bottom: unset;\n    width: fit-content;\n  }\n\n  .ui-timepicker-div dl {\n    text-align: center !important;\n  }\n\n  .ui-datepicker td a {\n    padding: 0.2em;\n  }\n\n  .ui-datepicker .ui-datepicker-buttonpane button {\n    padding: 0.2em 0.6em 0.3em 0.6em;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
